// this context is for test env only
// eslint-disable-next-line local-rules/no-import-from-test
import {LocationShim} from 'common/test/isotests/shims/location-shim';

import {UrlManager} from './types';

export class DummyUrlManager implements UrlManager {
  private location: LocationShim;

  constructor({params = {}, pathname = ``, hash = ``} = {}) {
    this.location = new LocationShim();
    const searchParams = new URLSearchParams(params);
    let url = `${window.location.origin}${pathname}`;
    if (hash) {
      url += `#${hash}`;
    }
    if (searchParams.toString()) {
      url += `?${searchParams.toString()}`;
    }
    this.location.assign(url);
  }

  getPath() {
    return this.location.pathname;
  }

  getHash() {
    return this.location.hash;
  }

  getQueryStringParam(paramName: string) {
    let paramVal = new URLSearchParams(this.location.search).get(paramName);
    if (paramVal === null) {
      paramVal = new URLSearchParams(this.location.hash).get(paramName); // wtf dashboards
    }
    return paramVal;
  }

  getLocation() {
    return this.location;
  }

  setLocation(url) {
    this.location.assign(url);
  }

  // don't do anthing in test env
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  openInNewTab(..._args): void {}

  historyReplaceState(_data: any, _unused: string, url: string): void {
    // TODO: potentially make this compatible with more than just hash
    this.location.hash = url.split(`#`)[1];
  }

  historyPushState(_data: any, _unused: string, url: string): void {
    // TODO: potentially make this compatible with more than just hash
    this.location.hash = url.split(`#`)[1];
  }
}
